export const formatNumber = (num: number) =>
  num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')

export const formatDollars = (total: number) => {
  if (total >= 1000000) {
    return `$${Math.trunc((total / 1000000)*10)/10}M`
  } else if (total >= 1000) {
    return `$${Math.trunc((total / 1000)*10)/10}K`
  } else {
    return `$${Math.trunc(total)}`
  }
}
